export const enum QueryKey {
  COTIZATION_FLOW = "cotization-flow",
  REQUEST_ID = "request-id"
}
